<template>
    <div class="account">
        <a-page-header
        style="border: 1px solid rgb(235, 237, 240);background:#fff;padding:16px 32px"
        :breadcrumb="{ props: { routes } }"
        />
        <div class="account-deatil" style="background:#fff;">
            <a-card>
                <div class="search">
                    <a-button type="primary" style="margin-left:14px" @click="addmodal">添加菜单</a-button>
                </div>
                <a-table
                    :columns="columns"
                    :pagination="pagination"
                    :loading="loading"
                    :data-source="data"
                >
                    <span slot="switch" slot-scope="is_show">
                        
                        <a-switch  
                            :default-checked="is_show === 1? true : false"
                            :checked-children="is_show === 1? '显示' : '隐藏'"
                             @change="onChange" >
                        </a-switch>
                    </span>
                    <span slot="action" slot-scope="text, record">
                        <a-button type="primary" :size="size"  @click="editmodal($event)" :id="record.id"><a-icon type="edit" />编辑</a-button>
                        <a-button type="danger" :size="size" @click="deletemenu(index,$event)" :id="record.id"><a-icon type="delete"  />删除</a-button>
                    </span>
                </a-table>
            </a-card>
        </div>

        <!-- 添加/编辑菜单 -->
        <a-modal
            class="pwdmodal"
            title="添加菜单"
            cancelText="取消"
            okText="确定"
            width="600px"
            :visible="menumodal"
            :confirm-loading="confirmLoading"
            @ok="addmenu"
            @cancel="handleCancel"
            >
            <a-row>
                <a-col :span="5">
                    <label class="required-icon">所属父级：</label>
                </a-col>
                <a-col :span="16">
                    <a-tree-select
                        v-model="pid"
                        style="width: 100%"
                        :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                        :tree-data="treeData"
                        placeholder="--默认顶级--"
                        tree-default-expand-all
                        @change="addChange"
                    >
                    </a-tree-select>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="5">
                    <label class="required-icon">菜单名称：</label>
                </a-col>
                <a-col :span="16">
                    <a-input v-model="name"  placeholder="请输入菜单名称"></a-input>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="5">
                    <label >前端路由：</label>
                </a-col>
                <a-col :span="16">
                    <a-input v-model="route" placeholder="例：/page"></a-input>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="5">
                    <label >菜单路径：</label>
                </a-col>
                <a-col :span="16">
                    <a-input v-model="menu" placeholder="例：/page"></a-input>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="5">
                    <label>是否菜单：</label>
                </a-col>
                <a-col :span="16">
                    <a-radio-group class="ismenu" name="radioGroup" :default-value="1"  @change="changeMenu">
                        <a-radio :value="1">
                        菜单
                        </a-radio>
                        <a-radio :value="2">
                        功能
                        </a-radio>
                    </a-radio-group>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="5">
                    <label >菜单图标：</label>
                </a-col>
                <a-col :span="16">
                    <a-input v-model="icon" placeholder="例：home"></a-input>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="5">
                    <label>排序：</label>
                </a-col>
                <a-col :span="16">
                    <a-input v-model="sort" placeholder="数字越小越靠前"></a-input>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="5">
                    <label>状态：</label>
                </a-col>
                <a-col :span="16" style="padding-top:5px;display:flex">
                    <a-switch default-checked @change="onChange" />
                    <span style="line-height:24px;display:inline-block;margin-left:10px">默认开启</span>
                </a-col>
            </a-row>
        </a-modal>

        <!-- 编辑菜单 -->
        <a-modal
        class="pwdmodal"
        title="编辑菜单"
        cancelText="取消"
        okText="确定"
        width="600px"
        :visible="editmenumodal"
        :confirm-loading="confirmLoading"
        @ok="editmenu"
        @cancel="handleCancel"
        >
            <a-row>
                <a-col :span="5">
                    <label class="required-icon">所属父级：</label>
                </a-col>
                <a-col :span="16">
                    <a-tree-select
                        v-model="editdata.pid"
                        style="width: 100%"
                        :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                        :tree-data="treeData"
                        placeholder="--默认顶级--"
                        tree-default-expand-all
                        @change="editChange"
                    >
                    </a-tree-select>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="5">
                    <label class="required-icon">菜单名称：</label>
                </a-col>
                <a-col :span="16">
                    <a-input v-model="editdata.name"  placeholder="请输入菜单名称"></a-input>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="5">
                    <label >前端路由：</label>
                </a-col>
                <a-col :span="16">
                    <a-input v-model="editdata.route" placeholder=""></a-input>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="5">
                    <label >菜单路径：</label>
                </a-col>
                <a-col :span="16">
                    <a-input v-model="editdata.menu" placeholder="例：/page"></a-input>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="5">
                    <label>是否菜单：</label>
                </a-col>
                <a-col :span="16">
                    <a-radio-group class="ismenu" name="radioGroup" :value="editdata.is_menu"  @change="editchangeMenu">
                        <a-radio :value="1">
                        菜单
                        </a-radio>
                        <a-radio :value="2">
                        功能
                        </a-radio>
                    </a-radio-group>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="5">
                    <label >菜单图标：</label>
                </a-col>
                <a-col :span="16">
                    <a-input v-model="editdata.icon" placeholder="例：home"></a-input>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="5">
                    <label>排序：</label>
                </a-col>
                <a-col :span="16">
                    <a-input v-model="editdata.sort" placeholder="数字越小越靠前"></a-input>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="5">
                    <label>状态：</label>
                </a-col>
                <a-col :span="16" style="padding-top:5px;display:flex">
                    <a-switch :checked="editdata.is_show==1?true:false" @change="oneditChange" />
                    <span style="line-height:24px;display:inline-block;margin-left:10px">默认开启</span>
                </a-col>
            </a-row>
        </a-modal>

    </div>
</template>

<script>
import { Modal } from 'ant-design-vue';
const columns = [
  {
    title: 'ID',
    dataIndex: 'key',
    key: 'key',
  },
  {
    title: '菜单名称',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: '菜单路径',
    dataIndex: 'menu',
    key: 'menu',
  },
  {
    title: '菜单状态',
    dataIndex: 'is_show',
    key: 'is_show',
    scopedSlots: { customRender: 'switch' },
  },
  {
    title: '添加时间',
    dataIndex: 'create_time',
    key: 'create_time',
  },
  {
    title: '排序',
    dataIndex: 'sort',
    key: 'sort',
  },
  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
  },
];

export default {
    data(){
        return{
            routes: [
                {path:'home/main',breadcrumbName: '首页'},
                {breadcrumbName: '菜单管理'}
            ],
            columns,
            data:"",
            pagination:{},
            loading:false,
            size:'small',
            menumodal:false,
            editmenumodal:false,
            confirmLoading:false,
            treeData:"",
            value:undefined,
            is_show:1,
            name:"",
            menu:"",
            route:"",
            is_menu:1,
            
            pid:0,
            sort:"",
            id:"",
            editdata:"",
            icon:""
            // edit:{
            //     name: '',
            //     menu: '',
            //     is_menu
            // }
        }
    },
    mounted(){
        this.$axios.get('/api/getALLMenu',{
            headers:{
            "appid": this.appSet.appid,
            "appkey": this.appSet.appkey,
            "token":localStorage.getItem('token'),
            },
        }).then((res)=> {
            if(res.data.code==200){
                var data=res.data.data
                data=JSON.parse(JSON.stringify(data).replace(/child/g, 'children'));
                this.data=data
                data=JSON.parse(JSON.stringify(data).replace(/name/g, 'title'));
                data=JSON.parse(JSON.stringify(data).replace(/id/g, 'value'));
                var obj = new Object();
 
                obj.title='--默认顶级--';
                
                obj.value="0";
                data.unshift(obj);
                // for(var i in data){
                //     if(data[i].child.length==0){
                //         data[i].
                //     }
                // }
                this.treeData=data
            }
        })
    },
    methods:{
        deletemenu(index,event){
            var editid=event.currentTarget.id
        
            Modal.confirm({
                title: '提示',
                content: '您确定删除此菜单吗?',
                okText: '确定',
                okType: 'danger',
                cancelText: '取消',
                onOk:() => {
                    this.handok(editid)
                },
                onCancel() {

                },
            });
        },
        handok(editid){
            var params=new URLSearchParams()
            params.append('id',editid)
            this.$axios.post('/api/delmenu',params,{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }  
            }).then((res)=>{
                if(res.data.code==40014){
                   this.$message.warning(res.data.msg); 
                }else if(res.data.code==200){
                    this.$message.success('删除成功');
                    this.$axios.get('/api/getALLMenu',{
                        headers:{
                        "appid": this.appSet.appid,
                        "appkey": this.appSet.appkey,
                        "token":localStorage.getItem('token'),
                        },
                    }).then((res)=> {
                        if(res.data.code==200){
                            var data=res.data.data
                            data=JSON.parse(JSON.stringify(data).replace(/child/g, 'children'));
                            this.data=data
                            data=JSON.parse(JSON.stringify(data).replace(/name/g, 'title'));
                            data=JSON.parse(JSON.stringify(data).replace(/id/g, 'value'));
                            var obj = new Object();
            
                            obj.title='--默认顶级--';
                            
                            obj.value="0";
                            data.unshift(obj);
                            this.treeData=data
                        }
                    })
                }else{
                    this.$message.success(res.data.msg);
                }
            })
        },
        addmenu(){
            var params=new URLSearchParams()
            params.append('name',this.name)
            params.append('menu',this.menu)
            params.append('pid',this.pid)
            params.append('is_menu',this.is_menu)
            params.append('is_show',this.is_show)
            params.append('sort',this.sort)
            params.append('route',this.route)
            params.append('icon',this.icon)
            this.$axios.post('/api/addmenu',params,{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success('添加成功'); 
                    this.menumodal=false
                    this.$axios.get('/api/getALLMenu',{
                        headers:{
                        "appid": this.appSet.appid,
                        "appkey": this.appSet.appkey,
                        "token":localStorage.getItem('token'),
                        },
                    }).then((res)=> {
                        if(res.data.code==200){
                            var data=res.data.data
                            data=JSON.parse(JSON.stringify(data).replace(/child/g, 'children'));
                            this.data=data
                            data=JSON.parse(JSON.stringify(data).replace(/name/g, 'title'));
                            data=JSON.parse(JSON.stringify(data).replace(/id/g, 'value'));
                            var obj = new Object();
            
                            obj.title='--默认顶级--';
                            
                            obj.value="0";
                            data.unshift(obj);
                            this.treeData=data
                        }
                    })
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })
        },
        edit(event){
           
        },

        // 编辑菜单
        editmenu(){
           this.editmenumodal=true
            var id=event.currentTarget.id
            var params=new URLSearchParams()
            params.append('id',this.editdata.id)
            params.append('name',this.editdata.name)
            params.append('menu',this.editdata.menu)
            params.append('pid',this.editdata.pid)
            params.append('is_menu',this.editdata.is_menu)
            params.append('is_show',this.editdata.is_show)
            params.append('sort',this.editdata.sort)
            params.append('route',this.editdata.route)
            params.append('icon',this.editdata.icon)
            this.$axios.post('/api/editmenu',params,{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success('编辑成功');
                    this.editmenumodal=false
                    this.$axios.get('/api/getALLMenu',{
                        headers:{
                        "appid": this.appSet.appid,
                        "appkey": this.appSet.appkey,
                        "token":localStorage.getItem('token'),
                        },
                    }).then((res)=> {
                        if(res.data.code==200){
                            var data=res.data.data
                            data=JSON.parse(JSON.stringify(data).replace(/child/g, 'children'));
                            this.data=data
                            data=JSON.parse(JSON.stringify(data).replace(/name/g, 'title'));
                            data=JSON.parse(JSON.stringify(data).replace(/id/g, 'value'));
                            var obj = new Object();
            
                            obj.title='--默认顶级--';
                            
                            obj.value="0";
                            data.unshift(obj);
                            this.treeData=data
                        }
                    })
                }
            }) 
        },
        handleCancel(){
            this.menumodal=false,
            this.editmenumodal=false
        },
        addmodal(){
            this.menumodal=true
        },
        onChange(checked) {
            if(checked==true){
                this.is_show=1
            }else if(checked==false){
                this.is_show=2
            }
        },
        oneditChange(checked){
            if(checked==true){
                this.editdata.is_show=1
            }else if(checked==false){
                this.editdata.is_show=2
            }
        },
        editmodal(event){
            this.editmenumodal=true
            var id=event.currentTarget.id
            var params=new URLSearchParams()
            params.append('id',id)
            this.$axios.get('/api/getmenudetail',{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    id:id
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.editdata=res.data.data
                }
            })
        },
        changeMenu(e) {
            this.is_menu=e.target.value;
        },
        editchangeMenu(e){
            this.editdata.is_menu=e.target.value
        },
        addChange(value){
            this.pid=value
            console.log("pid="+this.pid)
        },
        editChange(value){
            this.editdata.pid=value
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/menu/index.vue